<div class="responsive-menu-container" #menuContainer>
  <!-- Dynamic menu items -->
  <ng-container *ngTemplateOutlet="dynamicMenuItemsTemplateRef"> </ng-container>

  <div #triggerButtonContainer>
    <div *ngIf="dynamicMenuItemsInPopupMenu.length > 0 || staticMenuItems.length > 0">
      <!-- Menu Trigger Button -->
      <ng-template *ngTemplateOutlet="menuTriggerButtonTemplateRef; context: { $implicit: menu }">
      </ng-template>
    </div>

    <!-- TODO: xPosition should support dir=rtl (after) -->
    <mat-menu #menu="matMenu" xPosition="before" [aria-labelledby]="menuTriggerButtonId">
      <ul>
        <!-- Dynamic menu items in popup menu -->
        <li
          *ngFor="let menuItem of dynamicMenuItemsInPopupMenu; let i = index"
          [class.top-divider]="i > 0 && menuItem?.divider">
          <!-- We have to have the mat-meu-items here rather than using the accredible-menu-item in order to allow the focus to be moved from the trigger button to the first element in the menu -->
          <a
            *ngIf="menuItem?.routerLink; else externalLinkTemplate"
            mat-menu-item
            [routerLink]="menuItem?.routerLink"
            [queryParams]="menuItem?.queryParams"
            [disabled]="menuItem?.disabled">
            <accredible-icon
              *ngIf="menuItem?.icon"
              class="trailing-margin"
              [icon]="menuItem?.icon.name">
            </accredible-icon>
            <span>{{ menuItem?.label | syncOrAsync }}</span>
          </a>

          <ng-template #externalLinkTemplate>
            <a
              *ngIf="menuItem?.externalLink | syncOrAsync; else actionTemplate"
              mat-menu-item
              [href]="menuItem?.externalLink | syncOrAsync"
              [disabled]="menuItem?.disabled"
              [attr.target]="menuItem?.externalLinkTargetBlank ? '_blank' : null">
              <accredible-icon
                *ngIf="menuItem?.icon"
                class="trailing-margin"
                [icon]="menuItem.icon?.name">
              </accredible-icon>
              <span>{{ menuItem?.label | syncOrAsync }}</span>
            </a>
          </ng-template>

          <ng-template #actionTemplate>
            <button
              *ngIf="menuItem?.actionBtn"
              mat-menu-item
              (click)="menuItem?.actionBtn(true)"
              [disabled]="menuItem?.disabled">
              <accredible-icon
                *ngIf="menuItem?.icon"
                class="trailing-margin"
                [icon]="menuItem?.icon.name">
              </accredible-icon>
              <span>{{ menuItem?.label | syncOrAsync }}</span>
            </button>
          </ng-template>
        </li>

        <!-- Static menu items in popup menu -->
        <li
          *ngFor="let menuItem of staticMenuItems; let i = index"
          [class.top-divider]="
            (i > 0 || dynamicMenuItemsInPopupMenu.length > 0) && menuItem.divider
          ">
          <!-- We have to have the mat-meu-items here rather than using the accredible-menu-item in order to allow the focus to be moved from the trigger button to the first element in the menu -->
          <a
            *ngIf="menuItem?.routerLink; else externalLinkTemplate"
            mat-menu-item
            [routerLink]="menuItem?.routerLink"
            [queryParams]="menuItem?.queryParams"
            [disabled]="menuItem?.disabled">
            <accredible-icon
              *ngIf="menuItem?.icon"
              class="trailing-margin"
              [icon]="menuItem?.icon.name">
            </accredible-icon>
            <span>{{ menuItem?.label | syncOrAsync }}</span>
          </a>

          <ng-template #externalLinkTemplate>
            <a
              *ngIf="menuItem?.externalLink | syncOrAsync; else actionTemplate"
              mat-menu-item
              [href]="menuItem?.externalLink | syncOrAsync"
              [disabled]="menuItem?.disabled"
              [attr.target]="menuItem?.externalLinkTargetBlank ? '_blank' : null">
              <accredible-icon
                *ngIf="menuItem?.icon"
                class="trailing-margin"
                [icon]="menuItem.icon?.name">
              </accredible-icon>
              <span>{{ menuItem?.label | syncOrAsync }}</span>
            </a>
          </ng-template>

          <ng-template #actionTemplate>
            <button
              *ngIf="menuItem?.actionBtn"
              mat-menu-item
              (click)="menuItem?.actionBtn(true)"
              [disabled]="menuItem?.disabled">
              <accredible-icon
                *ngIf="menuItem?.icon"
                class="trailing-margin"
                [icon]="menuItem?.icon.name">
              </accredible-icon>
              <span>{{ menuItem?.label | syncOrAsync }}</span>
            </button>
          </ng-template>
        </li>
      </ul>
    </mat-menu>
  </div>
</div>
